export const PLACE_SELECTS_WIDTH = {
  WIDTH_390PX: 'width390px',
  WIDTH_100PR: 'width100pr',
};

export const SIZE = {
  SMALL: 'small',
  REGULAR: 'regular',
};
